module.exports = __webpack_public_path__ + "img/湖北宜化.6eed2a2e.png";